// extracted by mini-css-extract-plugin
export default {"card":"T5-z"};